<div class="root">
  <div class="title-row">
    @if (mobile) {
      <app-icon-button (click)="back()" colorVariant="secondary-dark" icon="arrow_back" size="small"/>
    }
    <div class="title-column">
      <div class="typo-h2">{{ "appointmentSelection.timeSelection.title" | transloco }}</div>
      <div class="type-h2-sub">{{ day }}</div>
    </div>
  </div>

  <div class="time-slots">
    @for (timeSlotModel of appointmentSelectionService.timeSlotModels; track timeSlotModel) {
      <app-text-button (click)="selectTimeSlot(timeSlotModel)" [colorVariant]="isSelected(timeSlotModel) ? 'primary' : 'tertiary'"
                       [text]="(timeSlotModel.startTime | customDate:'HH:mm') + ' - ' + (timeSlotModel.endTime | customDate:'HH:mm')"
                       size="small"
                       type="square"/>
    }
  </div>
</div>
